import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=491b23f8&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"
import style0 from "./folder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports